<template>
    <v-container container--fluid>
        <v-layout row wrap align-center justify-space-around class="pa-2 mx-auto">
            <v-flex xs12 class="text-left">
                <h1 class="grey--text lighten-3 mb-2">Competition Availability</h1>

                <v-snackbar v-model="overlay" :multi-line="true" centered :color="overlayColor" elevation="12" text>
                    <span v-html="overlayText"></span>

                    <template v-slot:action="{ attrs }">
                        <v-btn :color="overlayColor" text v-bind="attrs" @click="overlay = false"> Close<v-icon medium right>highlight_off</v-icon> </v-btn>
                    </template>
                </v-snackbar>

                <v-overlay :value="loading">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </v-overlay>

                <v-row>
                    <v-col cols="12" sm="4" md="4">
                        <v-select
                            :loading="loading"
                            item-text="season_name"
                            item-value="season_id"
                            v-model.trim="sel_season"
                            :items="seasons"
                            label="Seasons"
                            hint="Select a season"
                            persistent-hint
                            outlined
                        ></v-select>
                    </v-col>
                    <v-col cols="12" sm="5" md="5">
                        <v-select
                            :loading="loading"
                            item-text="venue_name"
                            item-value="venue_id"
                            v-model.trim="sel_venue"
                            :items="venues"
                            label="Venues"
                            hint="Venue selection does not affect availability times. ONLY works for unavailable dates."
                            persistent-hint
                            outlined
                            clearable
                        ></v-select>
                    </v-col>
                    <v-col cols="12" sm="3" md="3">
                        <v-btn block class="btnShowAvailability" :loading="loading" color="primary" @click="getAvailability">MY AVAILABILITY<v-icon right>schedule</v-icon></v-btn>
                    </v-col>
                </v-row>

                <div v-if="availability.days && showAvailability">
                    <p class="my-4 text-left subtitle-1 red--text font-weight-bold"><i>By completing your availability, you are agreeing to receive payments under the PAYG Declaration. These payments are not subject to withholding tax.</i></p>
                    <v-btn block class="btnShowAvailability my-3" outlined :loading="loading" color="warning" @click="postAvailability">SAVE <v-icon right>save</v-icon></v-btn>

                    <v-tabs v-model="tab" grow hide-slider active-class="active-tab-item" class="mb-3">
                        <v-tab>Availability<br class="d-sm-none"> Timeslots</v-tab>
                        <v-tab>Unavailable<br class="d-sm-none"> Dates</v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tab">
                        <v-tab-item class="pt-2">
                            <v-row v-for="(day, index) in availability.days" :key="index" v-if="availability.availability[day]">
                                <div class="col mt-4 round-wrapper pa-0">
                                    <v-col cols="12">
                                        <!-- <v-flex> -->
                                            <!-- <div class="d-flex flex-column pa-3 mb-1 elevation-2"> -->
                                                <div class="text-center mb-1">{{ day }}</div>
                                                <v-divider class="my-2"></v-divider>
                                                <div class="time-avail">
                                                    <div @click="addAvail(day, timeAvail)" v-for="(timeAvail, indexAT) in availability.availability[day]" :key="indexAT" v-if="timeAvail" :class="{active: isActiveRef(day, timeAvail)}">{{timeAvail}}
                                                    </div>
                                                </div>
                                            <!-- </div> -->
                                        <!-- </v-flex> -->
                                    </v-col>
                                </div>
                            </v-row>
                        </v-tab-item>
                        <v-tab-item class="pt-2">
                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-date-picker full-width v-model="unavail_date" multiple @click:date="updateUnavail"></v-date-picker>
                                    <v-divider class="d-sm-none my-2"></v-divider>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-list dense>
                                        <v-subheader><v-icon left>event</v-icon> Unavailable Dates</v-subheader>
                                        <v-list-item-group color="primary">
                                            <v-list-item v-for="(item, i) in dateRangeText" :key="i">
                                                <v-list-item-content>
                                                    <v-list-item-title v-text="item"></v-list-item-title>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <v-btn icon ripple @click.native="removeUnavail(unavail_date[i])">
                                                        <v-icon class="red--text text--lighten-1">delete</v-icon>
                                                    </v-btn>
                                                </v-list-item-action>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </v-col>
                            </v-row>
                        </v-tab-item>
                    </v-tabs-items>

                    <v-row>
                        <v-col cols="12" sm="12" md="12">
                            <v-btn block class="btnShowAvailability mt-3" outlined :loading="loading" color="warning" @click="postAvailability">SAVE <v-icon right>save</v-icon></v-btn>
                        </v-col>
                    </v-row>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import store from "@modules/referee/_store";
import moment from "moment";

export default {
    name: "RefereeAvailModule",
    data() {
        return {
            tab: null,
            sel_season: null,
            sel_venue: null,
            unavail_date: {},
            origAvailability: [],
            menu: false,
            showAvailability: false,
            dayNumArr: {'monday':1,'tuesday':2,'wednesday':3,'thursday':4,'friday':5,'saturday':6,'sunday':7},
            dayMomentArr: {'monday':1,'tuesday':2,'wednesday':3,'thursday':4,'friday':5,'saturday':6,'sunday':0},
            overlayColor: "sucess darken-2",
            overlay: false,
            overlayText: "",
            timeout: 1000,
        };
    },
    computed: {
        dateRangeText () {
            return this.unavail_date.length ? this.unavail_date.map(item => moment(item).format("DD/MM/YYYY")) : [];
        },
        computedDateFormatted() {
            return this.unavail_date ? moment(this.unavail_date).format("DD/MM/YYYY") : "";
        },
        loading() {
            return this.$store.getters["referee/refereeStatus"] == "loading";
        },
        seasons() {
            return this.$store.getters["referee/seasons"];
        },
        venues() {
            return this.$store.getters["referee/venues"];
        },
        availability() {
            return this.$store.getters["referee/availability"];
        },
    },
    watch: {
        sel_season(n, o) {
            this.showAvailability = false;
        },
        sel_venue(n, o) {
            this.showAvailability = false;
        },
    },
    methods: {
        isActiveRef(day, time) {
            let dayNum = this.dayNumArr[day.toLowerCase()];

            if(this.availability.refGameTimes[dayNum]){
                if(this.availability.refGameTimes[dayNum].includes(time)){
                    return true;
                }
            }

            return false;
        },
        updateUnavail(date) {
            let unavail_arr = this.unavail_date;

            if(!this.availability.refRosteredPublished.includes(date)){
                this.$store.dispatch("referee/updateUnavail", { unavail_arr });
            } else {
                this.removeUnavail(date);

                this.overlayColor = "error";
                this.overlay = true;
                this.overlayText = "Roster already published, please contact the stadium";

                setTimeout(() => {
                    this.overlayColor = "primary";
                    this.overlay = false;
                    this.overlayText = "";
                }, 3000);
            }
        },
        removeUnavail(unavail_day) {
            if(this.unavail_date.includes(unavail_day)){
                this.unavail_date = this.unavail_date.filter(item => item !== unavail_day);
            } else {
                this.unavail_date.push(unavail_day);
            }

            let unavail_arr = this.unavail_date;

            this.$store.dispatch("referee/updateUnavail", { unavail_arr });
        },
        addAvail(day, time) {
            let dayNum = this.dayNumArr[day.toLowerCase()];
            let dayMoment = this.dayMomentArr[day.toLowerCase()];

            if(moment().day() > 0 && dayMoment == 0){
                dayMoment = 7;
            }

            let now = moment(moment().day(dayMoment)).clone();
            let nextDates = [];
            while (now.isSameOrBefore(moment().add(4, 'weeks'))) {
                nextDates.push(now.format('YYYY-MM-DD'));
                now.add(1, 'weeks');
            }

            //check if day/time to remove is already part of published roster for this user
            //or if day is in same 4 weeks
            if(this.origAvailability.refGameTimes[dayNum] != undefined){
                if(this.origAvailability.refGameTimes[dayNum].includes(time)){
                    if(nextDates.some(value => this.origAvailability.refRosteredPublished.includes(value))){
                        this.overlayColor = "error";
                        this.overlay = true;
                        this.overlayText = "Roster already published, please contact the stadium";

                        setTimeout(() => {
                            this.overlayColor = "primary";
                            this.overlay = false;
                            this.overlayText = "";
                        }, 2000);
                    } else {
                        this.showAvailability = false;
                        this.$store.dispatch("referee/addAvail", { dayNum, time }).then(() => {
                            this.showAvailability = true;
                        });
                    }
                } else {
                    this.showAvailability = false;
                    this.$store.dispatch("referee/addAvail", { dayNum, time }).then(() => {
                        this.showAvailability = true;
                    });
                }
            }else{
                this.showAvailability = false;
                this.$store.dispatch("referee/addAvail", { dayNum, time }).then(() => {
                    this.showAvailability = true;
                });
            }

        },
        getAvailability() {
            if (this.sel_season /*&& this.sel_venue*/) {
                const { sel_season, sel_venue } = this;
                this.showAvailability = false;

                this.$store.dispatch("referee/getAvailability", { sel_season, sel_venue }).then((resp) => {
                    this.origAvailability = JSON.parse(JSON.stringify(resp.data));
                    this.unavail_date = this.availability.unavailability;
                    this.showAvailability = true;
                });
            }
        },
        postAvailability() {
            if (this.sel_season /*&& this.sel_venue*/) {
                const { sel_season, sel_venue } = this;
                // this.showAvailability = false;

                this.$store.dispatch("referee/postAvailability", { sel_season, sel_venue }).then(() => {
                    this.showAvailability = false;
                    this.overlay = true;
                    this.overlayText = "Availability updated successfully";

                    setTimeout(() => {
                        this.overlay = false;
                        this.showAvailability = true;
                    }, this.timeout);
                });
            }
        },
    },
    beforeCreate() {
        this.$store.dispatch("referee/getSeasons");
        this.$store.dispatch("referee/getVenues");
    },
};
</script>

<style lang="scss">
.time-avail {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: stretch;

    div {
        padding: 4px 4px;
        border: 1px solid #000;
        margin: 4px 4px;
        width: calc(10% - 8px);
        text-align: center;
        cursor: pointer;

        &:hover {
            background-color: var(--drawer-color) !important;
            border-color: var(--drawer-color) !important;
            color: #fff !important;
            caret-color: #fff !important;
        }

        &.active {
            background-color: var(--secondary-color) !important;
            border-color: var(--secondary-color) !important;
            color: #fff !important;
            caret-color: #fff !important;
        }
    }
}
.round-wrapper {
    .col.col-12 .flex:nth-of-type(n + 2) .bye-duty-team {
        display: none !important;
    }
}

.v-text-field__slot {
    input {
        border: none !important;
    }
}

.btnShowAvailability {
    min-height: 56px;
}

.v-tab {
    background: #eeeeee;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    margin: 0 1px;
}

.v-tab.active-tab-item.v-tab--active {
    background: var(--primary-color);
    color: #ffffff !important;
}

@media screen and (max-width: 767px) {
    .btnCal {
        min-width: 100% !important;
    }
    .time-avail {
        div {
            width: calc(25% - 8px);
        }
    }
    .v-slide-group__prev.v-slide-group__prev--disabled {
        display: none;
        min-width: 0 !important;
        width: 0 !important;
        flex-basis: 0 !important;
    }
}
</style>
